var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultDeliveryList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 24,
    viewBox: "0 0 78 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21128",
    "data-name": "\\uADF8\\uB8F9 21128",
    transform: "translate(-903 -330)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD328\\uC2A4_10308",
    "data-name": "\\uD328\\uC2A4 10308",
    transform: "translate(903 330)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0H66a12,12,0,0,1,0,24H12A12,12,0,0,1,12,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12 1 C 9.061790466308594 1 6.299446105957031 2.144199371337891 4.221824645996094 4.221822738647461 C 2.144203186035156 6.299444198608398 1 9.061788558959961 1 12 C 1 14.93821144104004 2.144203186035156 17.7005558013916 4.221824645996094 19.77817726135254 C 6.299446105957031 21.85580062866211 9.061790466308594 23 12 23 L 66 23 C 68.93820953369141 23 71.70055389404297 21.85580062866211 73.77817535400391 19.77817726135254 C 75.85579681396484 17.7005558013916 77 14.93821144104004 77 12 C 77 9.061788558959961 75.85579681396484 6.299444198608398 73.77817535400391 4.221822738647461 C 71.70055389404297 2.144199371337891 68.93820953369141 1 66 1 L 12 1 M 12 0 L 66 0 C 72.62742614746094 0 78 5.372577667236328 78 12 C 78 18.62742233276367 72.62742614746094 24 66 24 L 12 24 C 5.372581481933594 24 0 18.62742233276367 0 12 C 0 5.372577667236328 5.372581481933594 0 12 0 Z",
    stroke: "none",
    fill: "#ff6a13"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uAE30\\uBCF8_\\uBC30\\uC1A1\\uC9C0",
    "data-name": "\\uAE30\\uBCF8 \\uBC30\\uC1A1\\uC9C0",
    transform: "translate(942 347)",
    fill: "#ff6a13",
    fontSize: 14,
    fontFamily: "AppleSDGothicNeo-Regular, Apple SD Gothic Neo",
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30.82,
    y: 0
  }, "\uAE30\uBCF8"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Helvetica"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "\uBC30\uC1A1\uC9C0")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultDeliveryList);
export default __webpack_public_path__ + "static/media/defaultDeliveryList.2e2a318ffe9f7399ea0972ee03999db0.svg";
export { ForwardRef as ReactComponent };